// Payment-acceptance trust strip (WS4).
//
// Renders PayPal's official combined card-acceptance badge
// (`public/images/payment/cards-accepted.png` — PayPal + Visa +
// Mastercard + American Express + Discover in one transparent PNG that
// PayPal licenses merchants to display). One asset, one component, used
// on the Home footer, the Services trust strip, and the checkout payment
// step. No geo logic: the badge is a generic "cards accepted" signal;
// the Discover-in-Canada limitation surfaces at PayPal checkout, not here.

import { cn } from '../utils/cn';

export interface PaymentMethodsProps {
  /** Caption shown beneath the marks. Pass null to render the badge alone. */
  label?: string | null;
  /** Caption tone — `dark` for dark backgrounds (e.g. the footer). */
  tone?: 'light' | 'dark';
  className?: string;
}

// Native size is 316×40; render at 20px tall (width scales to 158).
const BADGE_SRC = '/images/payment/cards-accepted.png';

export const PaymentMethods = ({
  label = 'Secure checkout — major cards & PayPal accepted',
  tone = 'light',
  className,
}: PaymentMethodsProps) => {
  return (
    <div className={cn('flex flex-col items-center gap-2', className)}>
      <img
        src={BADGE_SRC}
        alt="Accepted payment methods: PayPal, Visa, Mastercard, American Express, Discover"
        width={158}
        height={20}
        loading="lazy"
        decoding="async"
        className="h-5 w-auto"
      />
      {label && (
        <p className={cn('text-[11px]', tone === 'dark' ? 'text-stone-400' : 'text-stone-500')}>
          {label}
        </p>
      )}
    </div>
  );
};
